import initialState from '../../../store/initialState';
import * as types from '../services/LoginActionType';

function authReducer(state = initialState.auth, action) {
    switch (action.type) {
        case types.LOGIN_REQUEST:
            return { ...state, isAuthLoading: true, isNoAccess: false, error: null, infoMessage: null, mfaData: null, mfaSetupData: null };
        case types.LOGIN_SUCCESS:
            return { ...state, isAuthLoading: false, isNoAccess: false, error: null, userData: action.payload, mfaData: null, mfaSetupData: null };
        case types.LOGIN_FAILURE:
            return { ...state, isAuthLoading: false, error: action.payload };
        case types.LOGIN_INFO:
            return { ...state, isAuthLoading: false, infoMessage: action.payload };

        case types.LOGOUT_REQUEST:
            return { ...state, isAuthLoading: true };
        case types.LOGOUT_SUCCESS:
            return { ...state, isAuthLoading: false, error: null, userData: null };
        case types.LOGOUT_FAILURE:
            return { ...state, isAuthLoading: false, error: action.payload };

        case types.NO_ACCESS:
            return { ...state, isNoAccess: action.payload };
        case types.RESET_NO_ACCESS:
            return { ...state, isNoAccess: false };

        // MFA (Authenticator TOTP)
        case types.MFA_REQUIRED:
            return { ...state, isAuthLoading: false, mfaData: action.payload, requiresMfa: true };
        case types.MFA_SETUP_REQUIRED:
            return { ...state, isAuthLoading: false, mfaSetupData: action.payload, requiresMfaSetup: true };
        case types.VERIFY_MFA_REQUEST:
            return { ...state, isMfaVerifying: true, mfaError: null };
        case types.VERIFY_MFA_SUCCESS:
            return { ...state, isMfaVerifying: false, mfaData: null, mfaSetupData: null, requiresMfa: false, requiresMfaSetup: false };
        case types.VERIFY_MFA_FAILURE:
            return { ...state, isMfaVerifying: false, mfaError: action.payload };
        case types.RESET_MFA_STATE:
            return { ...state, mfaData: null, mfaSetupData: null, requiresMfa: false, requiresMfaSetup: false, mfaError: null };

        default:
            return state;
    }
}
export default authReducer;